import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MasterService } from '../../services/master.service';
import { FormGroup, FormArray, FormControl, Validators, FormBuilder, ValidatorFn, AbstractControl } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CommonContact, Contact } from '../../models/contact';
import { CommonService } from '../../services/common.service';


@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})
export class EmailComponent implements OnInit, OnChanges {
  emailtypeList = [];
  @Input() contactForm: FormGroup;
  emailFormArray: FormArray;
  @Input() contactFilter: string[];
  @Input() contactformGroupName: string;
  @Input() commonContact: any;
  emailIdList = [];
  index = -1;
  objemail = {
    contactId: 0,
    transContactId: 0,
    contactData: '',
    active: true,
    lookupId: 0
  };
  contact: Contact = new Contact();
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  constructor(private masterService: MasterService, private formBuilder: FormBuilder, private common: CommonService) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.commonContact) {
      const frmGrp = this.contactForm.get(this.contactformGroupName) as FormGroup;
      const contactfrmgrp = frmGrp.get('contact') as FormArray;
      const length = contactfrmgrp.length;
      let ind = length;
      if (contactfrmgrp.length > 0) {
        while (ind >= 0) {
          contactfrmgrp.removeAt(ind);
          this.emailIdList.splice(ind, 1);
          ind--;
        }
      // }
    // }
      // if (this.commonContact.length === 0) {
      //   const length = contactfrmgrp.length;
      //   let i = length;
      //   while (i >= 0) {
      //     contactfrmgrp.removeAt(i);
      //     this.emailIdList.splice(i, 1);
      //     console.log(i, 'remmove');
      //     i--;
      //   }
        // for (let i = contactfrmgrp.length; contactfrmgrp.length < i; i--) {
        //   contactfrmgrp.removeAt(i);
        //   this.emailIdList.splice(i, 1);
        // }
      // } else {
        if (this.commonContact.contact) {
          for (let i = 0; this.commonContact.contact.length > i; i++) {
            contactfrmgrp.push(this.initcontact());
          }
          this.emailIdList = this.commonContact.contact;
          contactfrmgrp.setValue(this.emailIdList);
        }
      } else {
        if (this.commonContact.contact) {
          for (let i = 0; this.commonContact.contact.length > i; i++) {
            contactfrmgrp.push(this.initcontact());
          }
          this.emailIdList = this.commonContact.contact;
          contactfrmgrp.setValue(this.emailIdList);
        }
      }
    }
  }
  ngOnInit() {
    this.initForm();
  }
  initForm() {
    const frmGrp = this.contactForm.get(this.contactformGroupName) as FormGroup;
    frmGrp.addControl('emailaddress', new FormControl('', Validators.compose(
      [Validators.pattern(this.common.EmailRegX), Validators.minLength(1)])));
    frmGrp.addControl('contact', this.formBuilder.array([]));
  }
  initcontact(): FormGroup {
    return this.formBuilder.group({
      contactId: new FormControl(0),
      transContactId: new FormControl(0),
      contactData: new FormControl(),
      active: new FormControl(true),
      lookupId: new FormControl(0)
    });
  }

  add(e): void {
    // this.emailFormArray = this.contactForm.get(this.contactformGroupName) as FormArray;
    const frmgroup = this.contactForm.get(this.contactformGroupName) as FormGroup;
    const control = frmgroup.get('emailaddress');
    const contactfrmgrp = frmgroup.get('contact') as FormArray;
    if (control.value) {
      if (control.valid) {
        const exist = this.emailIdList.some((s, index) =>
          s.contactData === control.value && index !== this.index);
        if (exist) {
          control.setErrors({ alreadyExist: true });
        } else {
          if (this.index > -1) {
            this.emailIdList[this.index].contactData = control.value;
          } else {
            const hjhd = this.common.CloneObject(this.objemail);
            hjhd.contactData = control.value;
            hjhd.lookupId = frmgroup.get('lookupId').value;
            this.emailIdList.push(hjhd);
            contactfrmgrp.push(this.initcontact());
          }
          contactfrmgrp.setValue(this.emailIdList);
          control.reset();
          this.index = -1;
          control.clearValidators();
          control.markAsTouched();
          control.updateValueAndValidity();
        }
      } else {
        control.setErrors({ incorrect: true });
      }
    } else {
      control.setValidators(Validators.compose(
        [Validators.pattern(this.common.EmailRegX), Validators.minLength(1), Validators.required]));
      control.markAsTouched();
      control.updateValueAndValidity();
    }
  }
  removecontrol(data: any) {
    const frmgroup = this.contactForm.get(this.contactformGroupName) as FormGroup;
    const contactfrmgrp = frmgroup.get('contact') as FormArray;
    contactfrmgrp.removeAt(data);
    this.emailIdList.splice(data);
    this.index = -1;
  }
  editemail(index) {
    this.index = index;
    const frmgroup = this.contactForm.get(this.contactformGroupName) as FormGroup;
    const control = frmgroup.get('emailaddress');
    control.setValue(this.emailIdList[index].contactData);
  }
}
